import { ColData } from 'ufinet-web-components'
import { PercentangeCommission } from 'lib/percentangeCommission/PercentangeCommission';
import { IntlShape } from 'react-intl';

export const colsGlobalData = (
  intl: IntlShape,
  dataCommercialTeam: any,
  dataClientType: any,
  dataCommissionManagementType: any,
  dataEconomicModel: any,
  dataTerm: any,
  dataServiceType: any,
  ): ColData[] => [
  // header is the id to search the translate based on the data received
  // removing or typing the word false in the property nonFilterable is gonna show in the table header the filter
  // body you can customize the data you want to show, accept react component or just a simple html
  {
    field: 'serviceTypeName', header: 'COL.GLOBAL.SERVICE.TYPE.NAME', width: '200px', nonFilterable: false, editable: false, filterType: 'select',
    filterOptions: dataServiceType
  },
  {
    field: 'managementTypeName', header: 'COL.GLOBAL.MANAGEMENTTYPENAME', width: '200px', nonFilterable: false, editable: false, filterType: 'select',
    filterOptions: dataCommissionManagementType
  },
  {
    field: 'comercialTeamName', header: 'COL.GLOBAL.TEAM.NAME', width: '200px', nonFilterable: false, editable: true, filterType: 'select',
    filterOptions: dataCommercialTeam
  },
  {
    field: 'clientTypeName', header: 'COL.GLOBAL.TYPE.NAME', width: '200px', nonFilterable: false, editable: true, filterType: 'select',
    filterOptions: dataClientType
  },
  {
    field: 'termName', header: 'COL.GLOBAL.TERM.NAME', width: '200px', nonFilterable: false, editable: true, filterType: 'select',
    filterOptions: dataTerm
  },
  {
    field: 'economicModelName', header: 'COL.GLOBAL.ECONOMIC.MODEL.NAME', width: '200px', nonFilterable: false, editable: true, filterType: 'select',
    filterOptions: dataEconomicModel
  },
  {
    field: 'percentage', header: 'COL.GLOBAL.PERCENTAGE', width: '200px', nonFilterable: true, editable: true,
    body: (row: any) => <PercentangeCommission percentange={row.percentage} />
  },

]


